const VeriFyEmailModal = ({
  isVerifying = false,
  onVeriFy,
  onCancelVeriFy,
}) => {
  return (
    <div
      className="modal fade"
      id="veriFyEmail"
      tabIndex="-1"
      aria-labelledby="veriFyEmail"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content border-0 rounded-4 shadow-sm">
          <div className="modal-body p-4 p-sm-5">
            <div className="text-center">
              <div className="icon-wrapper mb-4">
                <span className="material-symbols-outlined fs-1 text-warning bg-warning bg-opacity-10 p-3 rounded-circle">
                  warning
                </span>
              </div>

              <h4 className="fw-bold mb-4 text-dark">Email Verification</h4>

              <p className="text-secondary mb-4 fs-6">
                Are you sure you want to verify these email addresses? This
                action cannot be undone.
              </p>

              <div className="d-flex flex-column flex-sm-row align-items-center justify-content-center gap-3 mt-4">
                <button
                  className="btn btn-primary btn-lg mail_vairable_text d-inline-flex align-items-center justify-content-center gap-2 fw-semibold w-100 w-sm-auto"
                  disabled={isVerifying}
                  onClick={onVeriFy}
                >
                  <span className="material-symbols-outlined">
                    check_circle
                  </span>
                  {isVerifying ? "Verifying..." : "Yes, Verify"}
                  {isVerifying && (
                    <div
                      className="spinner-border spinner-border-sm"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  )}
                </button>
                <button
                  className="btn btn-outline-primary btn-lg mail_vairable_text d-inline-flex align-items-center justify-content-center gap-2 fw-semibold w-100 w-sm-auto"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={onCancelVeriFy}
                  disabled={isVerifying}
                >
                  <span className="material-symbols-outlined">cancel</span>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VeriFyEmailModal;
